export const SHOWN_PROFILES = "SHOWN_PROFILES";
export const TUTORIALS_REQUEST = "TUTORIALS_REQUEST";
export const TUTORIALS_RESET_ALL = "TUTORIALS_RESET_ALL";